<div class="root mat">
  <dx-button
    *ngIf="isExpanded && !hideButton"
    icon="chevronup"
    (onClick)="onExpandClick()"
  ></dx-button>
  <dx-button
    *ngIf="!isExpanded && !hideButton"
    icon="chevrondown"
    (onClick)="onExpandClick()"
  ></dx-button>

  <div [hidden]="!isExpanded" class="collapsible">
    <div class="content" [style.max-height]="contentMaxHeight">
      <ng-content></ng-content>
    </div>
  </div>
</div>
